import { render, staticRenderFns } from "./dealerLeve.vue?vue&type=template&id=58deba0a&"
import script from "./dealerLeve.vue?vue&type=script&lang=js&"
export * from "./dealerLeve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports